import {combineReducers, createStore} from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import loaderReducer from "./reducers/loader";
import supportCountersReducer from "./SupportModule/reducers/counter";
import moderationCountersReducer from "./CampaignModule/reducers/moderations";
import paymentPendingCounterReducer from "./CampaignModule/reducers/payment_pendings";
import notificationCountersReducer from "./NotificationModule/reducers/counter";

const rootReducer = combineReducers({
    loader: loaderReducer,
    notificationCountersReducer,
    supportCountersReducer,
    moderationCountersReducer,
    paymentPendingCounterReducer
});

export const store = createStore(rootReducer, composeWithDevTools());

